var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-block w-100 text-center",attrs:{"href":_vm.url}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'download'],"size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }